"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var WindowFile_1 = require("../model/WindowFile");

var WindowFileConverter_1 = require("./WindowFileConverter");
/**
 * Default implementation of WindowFileConverter.
 * @author OPt
 */


var WindowFileConverterImpl =
/*#__PURE__*/
function (_WindowFileConverter_) {
  _inherits(WindowFileConverterImpl, _WindowFileConverter_);

  function WindowFileConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, WindowFileConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowFileConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowFileConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowFile_1.WindowFile(WindowFile_1.WindowFile.schema.id.valueOf(conversions.documentToClassId(source)), WindowFile_1.WindowFile.schema.fileId.valueOf(conversions.toClassReferenceId(source.fileId)), WindowFile_1.WindowFile.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), this.userInfoConverter.toObject(source.uploadedBy, conversions), WindowFile_1.WindowFile.schema.note.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        fileId: conversions.toDocumentReferenceId(source.fileId),
        windowId: conversions.toDocumentReferenceId(source.windowId)
      });
      Object.assign(result, {
        uploadedBy: this.userInfoConverter.toDocument(source.uploadedBy, conversions),
        note: source.note
      });
      return result;
    }
  }]);

  return WindowFileConverterImpl;
}(WindowFileConverter_1.WindowFileConverter);

WindowFileConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], WindowFileConverterImpl);
exports.WindowFileConverterImpl = WindowFileConverterImpl;